import React, { Component } from "react";
import { withAuth } from "../Auth/WithAuth";
import { authenticatedFetch } from "../../utils/apiClient";

let isMounted = false;

export default withAuth(
  class DeletedList extends Component {
    constructor(props) {
      super(props);
      this.state = {
        persons: {},
        editMode: false,
        updated: Date().toLocaleString()
      };

      this.getPersons = this.getPersons.bind(this);
    }

    async componentDidMount() {
      isMounted = true;
      this.getPersons();
    }

    componentWillMount() {
      clearInterval(this.interval);
    }
    componentDidUpdate() {
      // Authentication is now handled by WithAuth HOC
    }

    componentWillUnmount() {
      isMounted = false;
    }

    async getPersons() {
      try {
        authenticatedFetch("/api/admin/getDeletedPersons", {
          method: "get",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            pragma: "no-cache",
            "cache-control": "no-cache"
          }
        })
          .then(response => {
            return response.json();
          })
          .then(persondata => {
            this.setState({ persons: persondata });
            this.setState({ updated: Date().slice(16, 24) });
          })
          .catch(err => {
            console.log(err);
          });
      } catch (err) {
        console.log(err);
      }
    }

    render() {
      if (this.props.authenticated === null) return null;
      const personRows = [];
      for (let i = 0; i < this.state.persons.length; i++) {
        personRows.push(
          <tr key={i}>
            <td>{this.state.persons[i].code}</td>
            <td>{this.state.persons[i].text}</td>
            <td>{this.state.persons[i].rowNum}</td>
            <td>{this.state.persons[i].seatNum} </td>
            <td>{this.state.persons[i].firstName}</td>
            <td> {this.state.persons[i].lastName}</td>
            <td> {this.state.persons[i].phone}</td>
            <td>{this.state.persons[i].UpdatedBy.split("@")[0]}</td>
          </tr>
        );
      }

      let numberSigned = <h5>Antall slettede: {personRows.length} </h5>;

      return (
        <div className="SignupList">
          <h1>Brukerliste</h1>

          {numberSigned}
          <p>
            Sist oppdatert:{" "}
            {this.state.updated.toLocaleString("en-GB", { timeZone: "UTC" })}
          </p>
          <br />
          <button
            className="btn btno btn-success edit printHide "
            onClick={() => this.getPersons()}
          >
            Oppdater
          </button>
          <button
            className="btn btno btn-info edit printHide "
            onClick={() => {
              window.print();
            }}
          >
            Skriv ut
          </button>
          <br />
          <div className="printNewPage"></div>
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Kode</th>
                <th>Sletteårsak</th>
                <th>Rad</th>
                <th>Plass</th>
                <th>Fornavn</th>
                <th>Etternavn</th>
                <th>Telefon</th>
                <th>Slettet av</th>
              </tr>
            </thead>
            <tbody>{personRows}</tbody>
          </table>
        </div>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/Components/Admin/DeletedList.js